const idadeCompat = (data) => {
    return false
}

export default idadeCompat;